import useSWRMutation from 'swr/mutation';
import capsFetcher from '../../shared/capsFetcher';
import useApplication from '../read';

const approveLoanFetcher = async (url, { arg: data }) => {
  const res = await capsFetcher({
    method: 'POST',
    url: `${url}/approve_loan`,
    data,
  });
  return res.data;
};

const useApproveLoan = (options) => {
  const { data: application } = useApplication();
  return useSWRMutation(
    `/applications/${application.id}`,
    approveLoanFetcher,
    { populateCache: true, revalidate: false, ...options },
  );
};

export default useApproveLoan;
